import { gql } from "generated-graphql";

export const REQUIREMENTS_QUERY = gql(`
  query Requirements(
    $search: String
    $page: Int
    $pageSize: Int
    $sort: [SortModel!]
  ) {
    requirements(
      search: $search
      page: $page
      pageSize: $pageSize
      sort: $sort
    ) {
      count
      items {
        id
        submissionId
        tenantId
        facilityId
        state
        tenantName
        facilityName
        submissionType
        requirementStatus
        requirementJurisdictions
        taskDescription
        nextDueDate
        csmName
        csmEmail
        amName
        amEmail
        dataManagerName
        dataManagerEmail
        wasteManagerName
        wasteManagerEmail
        pocName
        pocEmail
      }
    }
  }
`);

export const REQUIREMENTS_OPT_IN_OPT_OUT_MUTATION = gql(`
  mutation RequirementsOptInOptOut(
    $requirementStatus: RequirementStatus!
    $comment: String!
    $submissionIds: [ID!]!
  ) {
    requirementsOptInOptOut(
      requirementStatus: $requirementStatus
      comment: $comment
      submissionIds: $submissionIds
    ) {
      updatedCount
      comments {
        id
        comment
      }
    }
  }
`);
